<template>
    <ModalWithButton
        name="create-promocion"
        title="Añadir promoción"
        button_title="Añadir promoción"
        @cerrar="this.promocion = {}"
    >
        <Form
            :promocion="promocion"
            @terminado="crearPromocion()" 
        />
    </ModalWithButton>  
</template>

<script>
    import ModalWithButton from '../../../components/ModalWithButton.vue';
    import Form from './Form.vue';

    export default {
        props: {
            event_id: {
                required: true,
                type: Number
            },
            session_id: {
                required: true,
                type: Number
            }
        },
        data() {
            return {
                promocion: {
                    discount_fixed: 0,
                    discount_percent: 0,
                    event_id: this.event_id,
                    session_id: this.session_id
                },
                modalName: 'create-promocion'
            }
        },
        methods: {
            crearPromocion() {
                this.promocion.filters = {};

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.promociones.create'), this.promocion).then(res => {
                    this.$toast.success(res.data.message);
                    this.cerrar();
                    this.$emit('creado');
                });
            },
            cerrar() {
                this.$modal.hide(this.modalName);
                this.promocion = {
                    discount_fixed: 0,
                    discount_percent: 0,
                    event_id: this.event_id,
                    session_id: this.session_id
                };
            }
        },
        components: {
            ModalWithButton, Form
        }
    }
</script>
